
import {merge} from 'lodash-es'

export default function mixin(options_) {
  const options = {...options_}

  const mixins = options.mixins
  if(mixins !== undefined) {
    delete options.mixins

    const states = []
    if(options.state !== undefined) {
      states.push(options.state)
      delete options.state
    }

    for(const mixin_ of mixins) {
      const mixin = {...mixin_}

      if(mixin.state !== undefined) {
        states.push(mixin.state)
        delete mixin.state
      }

      merge(options, mixin)
    }

    if(states.length === 1) {
      options.state = states[0]
    }
    else if(1 < states.length) {
      options.state = function() {
        return states.reduce((acc, val) => {
          return merge(acc, typeof val === 'function' ? val() : val)
        }, {})
      }
    }
  }

  return options
}
